/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpgradeCertificate } from './UpgradeCertificate';
import {
    UpgradeCertificateFromJSON,
    UpgradeCertificateFromJSONTyped,
    UpgradeCertificateToJSON,
    UpgradeCertificateToJSONTyped,
} from './UpgradeCertificate';

/**
 * 
 * @export
 * @interface UpgradeCertificatesResponse
 */
export interface UpgradeCertificatesResponse {
    /**
     * 
     * @type {Array<UpgradeCertificate>}
     * @memberof UpgradeCertificatesResponse
     */
    certificates?: Array<UpgradeCertificate>;
}

/**
 * Check if a given object implements the UpgradeCertificatesResponse interface.
 */
export function instanceOfUpgradeCertificatesResponse(value: object): value is UpgradeCertificatesResponse {
    return true;
}

export function UpgradeCertificatesResponseFromJSON(json: any): UpgradeCertificatesResponse {
    return UpgradeCertificatesResponseFromJSONTyped(json, false);
}

export function UpgradeCertificatesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgradeCertificatesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'certificates': json['certificates'] == null ? undefined : ((json['certificates'] as Array<any>).map(UpgradeCertificateFromJSON)),
    };
}

export function UpgradeCertificatesResponseToJSON(json: any): UpgradeCertificatesResponse {
    return UpgradeCertificatesResponseToJSONTyped(json, false);
}

export function UpgradeCertificatesResponseToJSONTyped(value?: UpgradeCertificatesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'certificates': value['certificates'] == null ? undefined : ((value['certificates'] as Array<any>).map(UpgradeCertificateToJSON)),
    };
}

